import { UnsafeAlternateLinks as UnsafeAlternateLinks$1, createI18nContext as createI18nContext$1, useLocale as useLocale$1 } from '@aviv-unified-frontend/runtime/i18n';
export { I18nProvider, Translation, useTranslation } from '@aviv-unified-frontend/runtime/i18n';

const createI18nContext = createI18nContext$1;
const UnsafeAlternateLinks = UnsafeAlternateLinks$1;
const useLocale = useLocale$1;

export { UnsafeAlternateLinks, createI18nContext, useLocale };
